import { openDB } from 'idb';

const DB_NAME = 'shabz_closet';
const VERSION = 1;

async function getDB() {
  return openDB(DB_NAME, VERSION, {
    upgrade(db) {
      if (!db.objectStoreNames.contains('garments'))
        db.createObjectStore('garments', { keyPath: 'barcode' });
      if (!db.objectStoreNames.contains('pending'))
        db.createObjectStore('pending', { keyPath: 'client_txn_id' });
      if (!db.objectStoreNames.contains('local_sales'))
        db.createObjectStore('local_sales', { keyPath: 'client_txn_id' });
      if (!db.objectStoreNames.contains('meta'))
        db.createObjectStore('meta', { keyPath: 'key' });
    },
  });
}

// ---- garment cache (for offline lookup) ----
export async function cacheGarments(garments) {
  const db = await getDB();
  const tx = db.transaction('garments', 'readwrite');
  await tx.store.clear();
  for (const g of garments) await tx.store.put(g);
  await tx.done;
  await setMeta('garments_synced_at', new Date().toISOString());
}

export async function getCachedGarment(barcode) {
  const db = await getDB();
  return db.get('garments', barcode);
}

export async function markCachedSold(barcode) {
  const db = await getDB();
  const g = await db.get('garments', barcode);
  if (g) { g.status = 'SOLD'; await db.put('garments', g); }
}

// ---- pending offline operations ----
export async function queuePending(op) {
  const db = await getDB();
  await db.put('pending', op);
}
export async function getPending() {
  const db = await getDB();
  return db.getAll('pending');
}
export async function removePending(client_txn_id) {
  const db = await getDB();
  await db.delete('pending', client_txn_id);
}
export async function countPending() {
  const db = await getDB();
  return db.count('pending');
}

// ---- local sales receipts (offline invoices) ----
export async function saveLocalSale(sale) {
  const db = await getDB();
  await db.put('local_sales', sale);
}
export async function getLocalSales() {
  const db = await getDB();
  return db.getAll('local_sales');
}
export async function updateLocalSale(client_txn_id, patch) {
  const db = await getDB();
  const s = await db.get('local_sales', client_txn_id);
  if (s) { Object.assign(s, patch); await db.put('local_sales', s); }
}

// ---- meta ----
export async function setMeta(key, value) {
  const db = await getDB();
  await db.put('meta', { key, value });
}
export async function getMeta(key) {
  const db = await getDB();
  const r = await db.get('meta', key);
  return r?.value;
}
